import React from 'react';
import { IconBrandYoutube, IconBrandInstagram, IconBrandX } from '@tabler/icons-react';
import { Link } from 'react-router-dom';

const Footer = () => {
    return (
        <footer className="bg-[var(--bg)] text-[var(--ink)] border-t border-[var(--line)] mt-16">
            <div className="w-11/12 max-w-7xl mx-auto py-12 grid grid-cols-1 md:grid-cols-3 gap-10">
                <div>
                    <h3 className="font-display text-xl mb-4">Bağlantılar</h3>
                    <ul className="space-y-3 text-sm text-[var(--muted)]">
                        <li>
                            <a
                                href="https://www.youtube.com/@SportsDigitale/featured"
                                className="inline-flex items-center gap-2 hover:text-[var(--accent)] transition-colors"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <IconBrandYoutube size={18} />
                                YouTube
                            </a>
                        </li>
                        <li>
                            <a
                                href="https://www.instagram.com/sportsdigitale/"
                                className="inline-flex items-center gap-2 hover:text-[var(--accent)] transition-colors"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <IconBrandInstagram size={18} />
                                Instagram
                            </a>
                        </li>
                        <li>
                            <a
                                href="https://x.com/SportsDigitale"
                                className="inline-flex items-center gap-2 hover:text-[var(--accent)] transition-colors"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <IconBrandX size={18} />
                                X
                            </a>
                        </li>
                    </ul>
                </div>

                <div>
                    <h3 className="font-display text-xl mb-4">Sports Digitale</h3>
                    <p className="text-sm text-[var(--muted)] leading-relaxed">
                        Sporun dijital dünyasına adım at. En güncel haberler, analizler, röportajlar ve
                        özgün içeriklerle spor tutkunlarını buluşturuyoruz.
                    </p>
                </div>

                <div>
                    <h3 className="font-display text-xl mb-4">Yasal Belgeler</h3>
                    <ul className="space-y-2 text-sm text-[var(--muted)]">
                        <li>
                            <Link to="/aydınlatma-beyani" className="hover:text-[var(--accent)] transition-colors">
                                Aydınlatma Beyanı
                            </Link>
                        </li>
                        <li>
                            <Link to="/cayma-hakki" className="hover:text-[var(--accent)] transition-colors">
                                Cayma Hakkı Metni
                            </Link>
                        </li>
                        <li>
                            <Link to="/gizlilik-politikasi" className="hover:text-[var(--accent)] transition-colors">
                                Gizlilik Politikası
                            </Link>
                        </li>
                        <li>
                            <Link to="/iade-degisim-politikasi" className="hover:text-[var(--accent)] transition-colors">
                                İade &amp; Değişim Politikası
                            </Link>
                        </li>
                    </ul>
                </div>
            </div>

            <div className="border-t border-[var(--line)]">
                <div className="w-11/12 max-w-7xl mx-auto py-5 flex flex-col md:flex-row justify-between items-center gap-3 text-xs text-[var(--muted)]">
                    <p>© {new Date().getFullYear()} Sports Digitale · Tüm hakları saklıdır</p>
                    <div className="flex items-center gap-4">
                        <a href="https://www.youtube.com/@SportsDigitale/featured" aria-label="YouTube" target="_blank" rel="noopener noreferrer">
                            <IconBrandYoutube size={18} className="hover:text-[var(--accent)] transition-colors" />
                        </a>
                        <a href="https://www.instagram.com/sportsdigitale/" aria-label="Instagram" target="_blank" rel="noopener noreferrer">
                            <IconBrandInstagram size={18} className="hover:text-[var(--accent)] transition-colors" />
                        </a>
                        <a href="https://x.com/SportsDigitale" aria-label="X" target="_blank" rel="noopener noreferrer">
                            <IconBrandX size={18} className="hover:text-[var(--accent)] transition-colors" />
                        </a>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
